<template>
  <div>
    <div class="index">
      <div class="banner">
        <el-carousel
          :interval="5000"
          trigger="click"
          arrow="never"
          height="37vw"
        >
          <el-carousel-item
            v-for="(item, index) in indexList.imgList"
            :key="index"
            @click.native="goAboutDetail(item.title)"
          >
            <img mode="heightFix" :src="item.imgUrl" class="slide-image" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="centerTitle flex flex-justify-content flex-align-items">
        {{ indexList.title }}
      </div>
      <div class="container2">
        <div class="w1200">
          <h3 class="flex align-start titleTip">
            <span class="num">1.</span>
            <span class="text flex columnbox align-start">
              {{indexList.container1.text}}<font>{{indexList.container1.textEN}}</font>
            </span>
          </h3>
          <div class="index-s1 flex" >
            <a class="s1-li flexbox columnbox" v-for="(item,index) in indexList.container1.containerList" :key="index" @click="goIndexDetail1(item.name)">
              <img
                :src="item.img"
                class="s1-img"
                :alt="item.name"
              />
              <h4>{{ item.name }}</h4>
              <div class="tip flex flex-justify-content">
                <img
                  :src="item.line"
                  class="s1-img"
                  :alt="item.name"
                />
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="section index-s2">
        <div class="w1200 index-s2-div">
          <h3 class="flex align-start titleTip">
            <span class="num">2.</span>
            <span class="text flex columnbox align-start">
              {{ indexList.container2.text }}
              <font>{{ indexList.container2.textEN }}</font>
            </span>
          </h3>
          <div class="s2-ul flex" >
            <a class="s2-li centerbox" v-for="(items,index) in indexList.container2.containerList" :key="index" @click="goIndexDetail2(items.name)">
              <div class="poster">
                <img
                  :src="items.img"
                  class="s2-img"
                  :alt="items.name"
                />
              </div>
              <p class="s2-li-text">{{ items.name }}</p>
            </a>
          </div>
        </div>
      </div>
      <div class="section index-s1 index-s3">
        <div class="w1200">
          <h3 class="flex align-start titleTip">
            <span class="num">3.</span>
            <span class="text flex columnbox align-start">
              {{ indexList.container3.text }}
              <font>{{ indexList.container3.textEN }}</font>
            </span>
          </h3>
          <div class="new-text"></div>
          <!--  -->
          <div class="s1-ul flex">
            <a class="s1-li col2 flex columnbox" v-for="(items,index) in indexList.container3.containerList" :key="index" @click="goIndexDetail3(items.name)">
              <div class="new-poster">
                <img
                  :src="items.img"
                  class="s1-img"
                  :alt="items.name"
                />
              </div>
              <h4>{{ items.name }}</h4>
              <span class="line"></span>
            </a>
          </div>
        </div>
      </div>
      <div class="centerTitle flex flex-justify-content flex-align-items">
        {{ indexList.title2 }}
      </div>
      <div class="section">
        <a class="centerbox w1200 index-s4" @click="goResearchInstitute()">
          <div class="poster">
            <img
              :src="indexList.img"
            />
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getScrollParent } from "../../commonJs/commonMethods";
import axios from "axios";
import { WOW } from "wowjs";
export default {
  metaInfo() {
    return {
      title: "首页-健新",
      meta: [
        { name: "keywords", content: "keyword1, keyword2, keyword3" },
        { name: "description", content: "Page description" },
      ],
    };
  },
  mounted() {
    const element = getScrollParent(this.$el);
    element.scrollTop = 0;
  },
  data() {
    return {
      indexList: {
        imgList:[],
        title:"",
        container1:{
          text:"",
          textEN:"",
          containerList:[]
        },
        container2:{
          text:"",
          textEN:"",
          containerList:[]
        },
        container3:{
          text:"",
          textEN:"",
          containerList:[]
        },
        title2:"",
        img:""
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let data = {
        Title: "首页内容",
        ForumTypeCode: "jxIndex",
      };
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
           this.indexList = JSON.parse(res.data.OutputData.Content)
            // 动画生效
            this.$nextTick(() => {
              new WOW({ live: false }).init();
            });
          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
    // 微创外科详情
    goIndexDetail1(name) {
      this.$router.push({
        name:"indexDetail1",
        query:{
            title:name
        }
      })
    },
    // 微创介入
    goIndexDetail2(name) {
      this.$router.push({
        name:"indexDetail2",
        query:{
            title:name
        }
      })
    },
    // 5G+AI机器人
    goIndexDetail3(name) {
      this.$router.push({
        name:"indexDetail3",
        query:{
            title:name
        }
      })
    },
    goResearchInstitute() {
      this.$emit("getIndex", 1);
      this.$router.replace({ name: "jxResearchInstitute" });
    },
    goAboutDetail(title) {
      if(title){
        this.$router.push({
          name:"aboutDetail",
          query:{
              title:title
          }
        })
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less'>
@import "../../assets/less/base.less";
.index {
  // 轮播图
  .el-carousel {
    .el-carousel__indicators--horizontal {
      bottom: 26px;
    }
    .el-carousel__button {
      width: 18px;
      height: 18px;
      display: inline-block;
      border-radius: 100%;
      background: transparent;
      border: 1px solid white;
      opacity: 0.5;
      margin: 0 6px;
      position: relative;
    }
    .el-carousel__button:after {
      content: "";
      display: block;
      width: 10px;
      height: 10px;
      border-radius: 100%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: white;
    }
    .is-active {
      opacity: 1;
      transform: scale(1.2);
    }
  }
  .slide-image {
    width: 100%;
    height: auto;
    cursor: pointer;
  } // 一体化手术室解决方案
  .centerTitle {
    width: 100%;
    color: #333;
    text-align: center;
    align-items: center;
    line-height: 1.7;
    font-weight: bold;
  }
  .centerTitle:before {
    content: "";
    background: url(../../assets/images/heart-l.png) center center no-repeat;
    background-size: 100% auto;
  }
  .centerTitle:after {
    content: "";
    background: url(../../assets/images/heart-r.png) center center no-repeat;
    background-size: 100% auto;
  }
  .titleTip {
    color: #333;
    line-height: 1.7;
    font-weight: bold;
    .num {
      color: rgba(0, 0, 0, 0.33);
      font-style: italic;
      line-height: 1;
    }
    .text {
      line-height: 1.5;
      color: #333;
      text-align: left;
      position: relative;
    }
    .text:after {
      content: "";
      background: #0072c8;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  } // 1、微创外科
  .index-s1 {
    a {
      text-decoration: none;
      color: #333;
      cursor: pointer;
    }
    .s1-li {
      height: auto;
      background: #fff;
      border: 1px solid #eeeeee;
      overflow: hidden;
      img {
        width: 100%;
        border: none;
        font-size: 0;
        outline-width: 0px;
        vertical-align: top;
      }
      // span.line {
      //   width: 126px;
      //   height: 12px;
      //   background: url(../images/line.png) center center no-repeat;
      //   background-size: 100% auto;
      // }
    }
    .s1-li:nth-child(3n) {
      margin-right: 0;
    }
    .s1-li:hover {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
      h4 {
        color: #197ecb;
      }
    }
    .s1-li:hover > .s1-img {
      -webkit-animation: animations 5s linear infinite alternate;
      animation: animations 13s linear infinite alternate;
    }

    @keyframes animations {
      0% {
        transform: translate3d(0, 0, 0) scale(1);
      }
      100% {
        transform: translate3d(-5.166%, 0, 0px) scale(1.15);
      }
    }
    .s1-li > h4 {
      color: #333;
      line-height: 1.2;
      text-align: center;
      display: block;
      font-weight: bold;
      color: #333;
    }
  } // 2、微创介入
  .index-s2 {
    width: 100%;
    background: url(../../assets/images/index-bg.jpg) center center no-repeat;
    background-size: auto 100%;
    .titleTip {
      .num {
        color: #fff;
      }
      .text {
        color: #fff;
        font {
          color: #fff;
        }
      }
      .text:after {
        background: #fff;
      }
    }
    .s2-ul {
      padding-left: 0;
      position: relative;
      justify-content: space-between;
      align-items: flex-start;
      -webkit-box-orient: vertical;

      .s2-li {
        height: auto;
        position: relative;
        .poster {
          position: relative;
          width: 100%;
          height: 0;
          padding-bottom: 62.7586%;
          z-index: 5;
          overflow: hidden;
          img {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            min-width: 100%;
            min-height: 100%;
            max-width: 100%;
            border: none;
            font-size: 0;
            outline-width: 0px;
            vertical-align: top;
          }
        }
        .s2-li-text {
          position: absolute;
          bottom: 0;
          left: 0;
          display: block;
          width: 100%;
          line-height: 2;
          text-align: center;
          background-color: rgba(0, 0, 0, 0.49);
          z-index: 15;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: white;
        }
      }
      .s2-li:hover {
        cursor: pointer;
        border: 1px solid white;
      }
    }
  } //3、5G+AI机器人
  .index-s3 {
    width: 100%;
    height: auto;
    .s1-ul {
      .s2-li {
        height: auto;
        position: relative;
        .poster {
          position: relative;
          width: 100%;
          height: 0;
          padding-bottom: 62.7586%;
          z-index: 5;
          overflow: hidden;
          img {
            position: absolute;
            left: 50%;
            top: 50%;
            -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            min-width: 100%;
            min-height: 100%;
            max-width: 100%;
            border: none;
            font-size: 0;
            outline-width: 0px;
            vertical-align: top;
          }
        }
        .s2-li-text {
          position: absolute;
          bottom: 0;
          left: 0;
          display: block;
          width: 100%;
          line-height: 2;
          text-align: center;
          background-color: rgba(0, 0, 0, 0.49);
          z-index: 15;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: white;
        }
      }
    }
  } //创新研究院
  .index-s4 {
    cursor: pointer;
    .poster {
      position: relative;
      width: 100%;
      height: 0;
      z-index: 5;
      overflow: hidden;
      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        min-width: 100%;
        min-height: 100%;
      }
    }
  } // pc端
  @media (min-width: 768px) {
    .banner {
      margin-top: 130px;
    } // 一体化手术室解决方案
    .centerTitle {
      margin: 50px auto;
      font-size: 30px;
      margin-bottom: 50px;
    }
    .centerTitle:before {
      width: 76px;
      height: 18px;
      margin: 0 16px;
    }
    .centerTitle:after {
      width: 76px;
      height: 18px;
      margin: 0 16px;
    }
    .container2 {
      .w1200 {
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-flex-direction: column;
        -moz-flex-direction: column;
        -ms-flex-direction: column;
        -o-flex-direction: column;
        flex-direction: column;
      } // height: 100%;
    } // 一体化手术室解决方案 -- 标题
    .titleTip {
      margin-bottom: 50px;
      .num {
        font-size: 60px;
        margin-right: 15px;
      }
      .text {
        font-size: 28px;
        padding-top: 14px;
        padding-bottom: 14px;
      }
      .text:after {
        width: 44px;
        height: 4px;
      }
      .text font {
        font-size: 14px;
      }
    } // 1、微创外科
    .index-s1 {
      margin-bottom: 60px;
      webkit-box-align: start;
      -moz-align-items: flex-start;
      -webkit-align-items: flex-start;
      align-items: flex-start;
      .s1-li {
        width: 386px;
        border-radius: 2px;
        margin-right: 20px;
        padding-bottom: 20px;
        .tip {
          width: 100%;
          img {
            width: 126px;
            height: 12px;
            margin: 0 auto;
          }
        }
      }
      .s1-li > h4 {
        font-size: 16px;
        padding: 15px 10px;
      }
    } // 2、微创介入
    .index-s2 {
      height: 679px;
      padding-top: 50px;
      .index-s2-div {
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-flex-direction: column;
        -moz-flex-direction: column;
        -ms-flex-direction: column;
        -o-flex-direction: column;
        flex-direction: column;
      }
      .titleTip {
        margin-bottom: 65px;
      }
      .s2-ul {
        .s2-li {
          .s2-li-text {
            font-size: 16px;
            padding: 9px 15px;
          }
        }
        .s2-li:hover {
          box-shadow: 0 0 20px rgba(255, 255, 255, 0.66);
        }
        .s2-li:first-child {
          width: 48.333%;
          flex: none;
        }
        .s2-li:nth-child(2) {
          width: 48.333%;
        }
      }
    } //3、5G+AI机器人
    .index-s3 {
      padding-top: 50px;
      .w1200 {
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-flex-direction: column;
        -moz-flex-direction: column;
        -ms-flex-direction: column;
        -o-flex-direction: column;
        flex-direction: column;
      }
      .new-text {
        width: 100%;
        height: 35px;
        color: #333;
        background: transparent;
      }
      .s1-li {
        margin-right: 0px;
      }
      .s1-li:first-child {
        width: 48.333%;
        -webkit-box-flex: 0;
        -ms-flex: none;
        flex: none;
      }
      .s1-li:nth-child(2) {
        width: 48.333%;
      }
      .s1-ul {
        margin-bottom: 60px;
        -webkit-box-pack: space-between;
        -webkit-justify-content: space-between;
        -moz-justify-content: space-between;
        -ms-justify-content: space-between;
        -o-justify-content: space-between;
        justify-content: space-between;
        webkit-box-align: start;
        -moz-align-items: flex-start;
        -webkit-align-items: flex-start;
        align-items: flex-start;
        .s2-li {
          .s2-li-text {
            font-size: 16px;
            padding: 9px 15px;
          }
        }
        .s1-li:hover {
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        }
      }
    } //创新研究院
    .index-s4 {
      margin-bottom: 60px;
      cursor: pointer;
      .poster {
        padding-bottom: 33.3%;
      }
    }
  } // 手机端
  @media screen and (max-width: 767px) and (min-width: 320px) {
    .banner {
      margin-top: 3.52rem;
    }
    .centerTitle {
      margin: 2rem auto;
      font-size: 1.64rem;
    }
    .centerTitle:before {
      width: 3.04rem;
      height: 0.72rem;
      margin: 0 0.96rem;
    }
    .centerTitle:after {
      width: 3.04rem;
      height: 0.72rem;
      margin: 0 0.96rem;
    }
    .container2 {
      width: 100%;
      padding: 0 1.44rem;
      .w1200 {
        padding: 0px;
      }
    } // 一体化手术室解决方案
    // 一体化手术室解决方案 -- 标题
    .titleTip {
      margin-bottom: 2rem;
      .num {
        font-size: 45px;
        margin-right: 1.2rem;
      }
      .text {
        font-size: 1.44rem;
        padding-top: 1.12rem;
        padding-bottom: 1.12rem;
      }
      .text:after {
        width: 1.92rem;
        height: 0.16rem;
      }
      .text font {
        font-size: 0.96rem;
      }
    } // 1、微创外科
    .index-s1 {
      margin-bottom: 2.4rem;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-flow: column;
      flex-flow: column;
      .s1-li {
        width: 100%;
        border-radius: 0.16rem;
        padding-bottom: 0.8rem;
        margin-bottom: 0.8rem;
        flex: none;
        .tip {
          display: none;
        }
      }
      .s1-li > h4 {
        font-size: 1.2rem;
        padding: 0.96rem 0.4rem;
      }
    } // 2、微创介入
    .index-s2 {
      height: auto;
      padding-top: 4rem;
      .titleTip {
        margin-bottom: 4.56rem;
      }
      .s2-ul {
        width: 100%;
        -webkit-box-direction: normal;
        -ms-flex-flow: column;
        flex-flow: column;
        .s2-li {
          width: 100%;
          margin-bottom: 0.96rem;
          .s2-li-text {
            font-size: 0.96rem;
            padding: 0.4rem 0.6rem;
          }
        }
        .s2-li:hover {
          box-shadow: 0 0 1.6rem rgba(255, 255, 255, 0.66);
        }
      }
    } //3、5G+AI机器人
    .index-s3 {
      padding-top: 2rem;
      margin-bottom: 0px !important;
      .titleTip {
        margin-bottom: 0.96rem;
      }
      .new-text {
        padding: 1.2rem 0;
        color: #333;
        background: transparent;
        margin-bottom: 0.6rem;
      }
      .s1-li {
        margin-right: 0px;
        width: 100%;
      }
      .s1-ul {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-flow: column;
        flex-flow: column;
        .s2-li {
          .s2-li-text {
            font-size: 1.28rem;
            padding: 0.72rem 1.2rem;
          }
        }
        .s1-li:hover {
          box-shadow: 0 0 0.8rem rgba(0, 0, 0, 0.2);
        }
      }
    } //创新研究院
    .index-s4 {
      margin-bottom: 2.4rem;
      cursor: pointer;
      .poster {
        padding-bottom: 33.3%;
      }
    } // 轮播图
    .el-carousel {
      .el-carousel__indicators--horizontal {
        bottom: 0.96rem;
      }
      .el-carousel__button {
        width: 1.28rem;
        height: 1.28rem;
      }
    }
  } //一行3个   宽固定1200px
  @media only screen and (min-width: 1200px) {
    .w1200 {
      height: 100%;
    }
    .contentHome {
      padding-top: 130px;
    }
  } //一行3个   宽94%
  @media screen and (max-width: 1199px) and (min-width: 960px) {
    .contentHome {
      padding-top: 130px;
    }
    .centerTitle {
      margin: 50px auto;
      font-size: 30px;
    }
  } //一行两个  宽固定386PX
  @media screen and (max-width: 959px) and (min-width: 842px) {
    .centerTitle {
      margin: 50px auto;
      font-size: 30px;
    }
    .contentHome {
      padding-top: 130px;
    }
    .s1-li {
      margin-top: 1.6rem;
      margin-right: 0px !important;
    }

    .index-s1 {
      -webkit-flex-wrap: wrap;
      -moz-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      -o-flex-wrap: wrap;
      flex-wrap: wrap;
      webkit-box-align: start;
      -moz-align-items: flex-start;
      -webkit-align-items: flex-start;
      align-items: flex-start;

      -webkit-box-pack: space-between;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      -ms-justify-content: space-between;
      -o-justify-content: space-between;
      justify-content: space-between;

      .s1-li:nth-child(1),
      .s1-li:nth-child(2) {
        margin-top: 0rem;
      }
    }
  } //一行1个
  @media screen and (max-width: 841px) and (min-width: 320px) {
    .contentHome {
      padding-top: 3.52rem;
    }
  }
}
</style>